(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scc-beanify-junior-lab"] && !Shopify.designMode) return;
  try {
    
(function(){
  "use strict";
  document.querySelectorAll(".scc-jrlab").forEach(function(root){
    if (root.getAttribute("data-jrlab-initialized") === "1") return;
    root.setAttribute("data-jrlab-initialized", "1");

    var choice = { character: "anna", shade: "warm", hair: "curls", gear: "glasses", package: "mission" };

    var guides = {
      anna: { name: "Anna", image: root.querySelector('[data-value="anna"] img').getAttribute("src") },
      "dr-roast": { name: "Dr. Roast", image: root.querySelector('[data-value="dr-roast"] img').getAttribute("src") },
      piper: { name: "Piper", image: root.querySelector('[data-value="piper"] img').getAttribute("src") }
    };
    var looks = {
      shade: { warm: "warm cocoa", gold: "golden glow", deep: "deep roast" },
      hair: { curls: "curly hair", swoop: "swooped hair", spikes: "spiky hair" },
      gear: { glasses: "glasses", cape: "a cape", headphones: "headphones" }
    };
    var packages = {
      mission: { name: "Mission Makers", icon: "🚀", place: "Moon Station", story: "A tiny comet has lost its way. Can your Bean buddy help the crew draw a safe route home?" },
      style: { name: "Style Studio", icon: "✨", place: "the Color Lab", story: "The color machine mixed up every costume. Your Bean buddy gets to invent a brand-new look." },
      creatures: { name: "Creature Crew", icon: "🐉", place: "Cloud Garden", story: "A friendly baby dragon needs help finding its favorite cloud. Follow the glittery footprints!" },
      halloween: { name: "Halloween Files", icon: "🎃", place: "Pumpkin Lane", story: "A polite little ghost misplaced the costume parade map. Your Bean buddy can save the night!" },
      birthday: { name: "Birthday Mission", icon: "🎉", place: "Confetti Station", story: "The party surprise is ready, but the confetti cannon has hiccups. Your Bean buddy has a plan." }
    };

    function select(group, value) {
      choice[group] = value;
      root.querySelectorAll('[data-group="' + group + '"]').forEach(function(button){
        var selected = button.dataset.value === value;
        button.classList.toggle("is-active", selected);
        button.setAttribute("aria-pressed", String(selected));
      });
    }

    root.querySelectorAll("[data-group]").forEach(function(button){
      button.addEventListener("click", function(){ select(button.dataset.group, button.dataset.value); });
    });

    var randomizeBtn = root.querySelector("[data-scc-jrlab-randomize]");
    if (randomizeBtn) randomizeBtn.addEventListener("click", function(){
      var groups = {
        character: Object.keys(guides),
        shade: Object.keys(looks.shade),
        hair: Object.keys(looks.hair),
        gear: Object.keys(looks.gear),
        package: Object.keys(packages)
      };
      Object.keys(groups).forEach(function(group){
        var values = groups[group];
        select(group, values[Math.floor(Math.random() * values.length)]);
      });
    });

    var launchBtn = root.querySelector("[data-scc-jrlab-launch]");
    if (launchBtn) launchBtn.addEventListener("click", function(){
      var card = root.querySelector("[data-scc-jrlab-card]");
      var guide = guides[choice.character];
      var selectedPackage = packages[choice.package];
      root.querySelector("[data-scc-jrlab-character]").setAttribute("src", guide.image);
      var buddy = root.querySelector("[data-scc-jrlab-buddy]");
      buddy.dataset.shade = choice.shade;
      buddy.dataset.hair = choice.hair;
      buddy.dataset.gear = choice.gear;
      root.querySelector("[data-scc-jrlab-icon]").textContent = selectedPackage.icon;
      root.querySelector("[data-scc-jrlab-story]").textContent =
        "Your " + looks.shade[choice.shade] + " Bean buddy with " + looks.hair[choice.hair] + " and " + looks.gear[choice.gear] + " joins " + guide.name + " at " + selectedPackage.place + ". " + selectedPackage.story;
      root.querySelector("[data-scc-jrlab-art]").className = "scc-jrlab__mission-art " + choice.package;
      root.querySelector("[data-scc-jrlab-title]").textContent = selectedPackage.name + ": mission ready";
      card.hidden = false;
      card.scrollIntoView({ behavior: "smooth", block: "start" });
      root.querySelector("[data-scc-jrlab-title]").focus({ preventScroll: true });
    });

    var againBtn = root.querySelector("[data-scc-jrlab-again]");
    if (againBtn) againBtn.addEventListener("click", function(){
      root.querySelector("[data-scc-jrlab-card]").hidden = true;
      var workbenchTitle = root.querySelector(".scc-jrlab__workbench h2");
      if (workbenchTitle) workbenchTitle.scrollIntoView({ behavior: "smooth", block: "start" });
      if (launchBtn) launchBtn.focus({ preventScroll: true });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scc-tea-discovery"] && !Shopify.designMode) return;
  try {
    
(function(){var b=document.querySelector('[data-scc-tea-listen]');if(!b)return;var note=document.querySelector('[data-scc-tea-listen-note]'),idle=b.textContent,audio=null;b.hidden=false;
function set(playing,label){b.setAttribute('aria-pressed',playing?'true':'false');b.textContent=label}
function fail(){if(audio){audio.pause();audio=null}set(false,idle);note.textContent='Audio could not play. Please try listening again.'}
function pause(){if(audio&&!audio.paused)audio.pause()}
b.addEventListener('click',function(){note.textContent='';
if(audio&&!audio.paused){audio.pause();return}
if(!audio){audio=new Audio(b.dataset.src);audio.preload='none';audio.addEventListener('pause',function(){if(audio&&!audio.ended)set(false,audio.currentTime>0?'Resume Piper’s tea introduction':idle)});audio.addEventListener('playing',function(){set(true,'Pause')});audio.addEventListener('ended',function(){audio=null;set(false,idle)});audio.addEventListener('error',fail)}
var p=audio.play();if(p&&p.catch)p.catch(fail)});
document.addEventListener('visibilitychange',function(){if(document.hidden)pause()});window.addEventListener('pagehide',pause);})();
(function(){document.querySelectorAll('[data-scc-tea-stories]').forEach(function(w){var s=w.querySelectorAll('.scc-tea__story'),b=w.querySelector('.scc-tea__more');if(!b||s.length<2)return;var i=0;function show(){s.forEach(function(d,k){d.hidden=k!==i;if(k!==i)d.open=false})}show();b.hidden=false;b.addEventListener('click',function(){i=(i+1)%s.length;show()})})})();

  } catch(e) { console.error(e); }
})();
})();
